import { type PaymentTransactionId, ECommercePaymentTransactionsStatus } from '@hooks-api/types/dataModel/eCommercePayments'
import { PaymentMethodType } from '@hooks-api/types/dataModel/payment'
import { type PaymentBaseStore, type PaymentTransactionBaseStore } from '../types'

/** 貨到付款沒有需要線上支付的項目 */
export const shouldPromptOrderPay = (
  paymentTransactionStatus: PaymentTransactionBaseStore['status'],
  appliedPaymentMethodType: PaymentBaseStore['appliedPaymentMethodType'],
): boolean => {
  if (appliedPaymentMethodType === PaymentMethodType.CASH_ON_DELIVERY) return false
  return paymentTransactionStatus === ECommercePaymentTransactionsStatus.PENDING
}

type PendingPaymentTransactionFields = Pick<PaymentTransactionBaseStore, 'id' | 'orderHash' | 'status'>

/** 頁面載入時是否要問「尚有待付款訂單，是否前往結帳？」 */
export const shouldRedirectToOrderPay = (
  paymentTransaction: PendingPaymentTransactionFields,
  appliedPaymentMethodType: PaymentBaseStore['appliedPaymentMethodType'],
): boolean => {
  if (!paymentTransaction.id && !paymentTransaction.orderHash) return false
  return shouldPromptOrderPay(paymentTransaction.status, appliedPaymentMethodType)
}

export const setAppliedRepaymentMethodId = (state: PaymentTransactionBaseStore, appliedRepaymentMethodId: number): PaymentTransactionBaseStore => {
  return {
    ...state,
    appliedRepaymentMethodId,
  }
}

export const setPaymentTransactionId = (state: PaymentTransactionBaseStore, paymentTransactionId: PaymentTransactionId): PaymentTransactionBaseStore => {
  return {
    ...state,
    id: paymentTransactionId,
  }
}

export const resetPaymentTransaction = (state: PaymentTransactionBaseStore): PaymentTransactionBaseStore => {
  return {
    ...state,
    id: null,
  }
}

export const setPaymentTransactionStatus = (state: PaymentTransactionBaseStore, paymentTransactionStatus: ECommercePaymentTransactionsStatus): PaymentTransactionBaseStore => {
  return {
    ...state,
    status: paymentTransactionStatus,
  }
}

export const setOrderHash = (state: PaymentTransactionBaseStore, orderHash: string): PaymentTransactionBaseStore => {
  return {
    ...state,
    orderHash,
  }
}

